const fluminense = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 26/27 - Uniforme 1",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2026",
      "fluminense 2026",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/26-27-01/uni0.jpg",
      "/images/brasil/serie-a/fluminense/26-27-01/uni1.jpg",
      "/images/brasil/serie-a/fluminense/26-27-01/uni2.jpg",
      "/images/brasil/serie-a/fluminense/26-27-01/uni3.jpg",
      "/images/brasil/serie-a/fluminense/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 26/27 - Uniforme 2",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2026",
      "fluminense 2026",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/26-27-02/uni0.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02/uni1.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02/uni2.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02/uni3.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 26/27 - Uniforme 2 (Feminino)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2026",
      "fluminense 2026",
      "fluminense feminino",
      "feminino fluminense",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/26-27-02-f/uni0.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02-f/uni1.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02-f/uni2.jpg",
      "/images/brasil/serie-a/fluminense/26-27-02-f/uni3.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 1",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 1 Manga Longa",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-01-mc/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-mc/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-mc/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-mc/uni3.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-mc/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 2",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/fluminense/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 3",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 1 (Feminino)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
      "fluminense feminino",
      "feminino fluminense",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-01-f/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-f/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-f/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-01-f/uni3.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 25/26 - Uniforme 3 (Feminino)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
      "fluminense feminino",
      "feminino fluminense",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/25-26-03-f/uni0.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03-f/uni1.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03-f/uni2.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03-f/uni3.jpg",
      "/images/brasil/serie-a/fluminense/25-26-03-f/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme 1",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2024",
      "fluminense 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-01/uni3.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme 2",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2024",
      "fluminense 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme 3",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2024",
      "fluminense 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-03/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-03/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-03/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-03/uni3.jpg",
      "/images/brasil/serie-a/fluminense/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme 2 (Feminino)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2025",
      "fluminense 2025",
      "fluminense feminino",
      "feminino fluminense",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-02-f/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-f/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-f/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-f/uni3.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-f/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme de Pré Jogo (Verde)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2024",
      "fluminense 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-02-pjv/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-pjv/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-pjv/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-pjv/uni3.jpg",
      "/images/brasil/serie-a/fluminense/24-25-02-pjv/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 24/25 - Uniforme de Goleiro (Laranja)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2024",
      "fluminense 2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/24-25-04-gl/uni0.jpg",
      "/images/brasil/serie-a/fluminense/24-25-04-gl/uni1.jpg",
      "/images/brasil/serie-a/fluminense/24-25-04-gl/uni2.jpg",
      "/images/brasil/serie-a/fluminense/24-25-04-gl/uni3.jpg",
      "/images/brasil/serie-a/fluminense/24-25-04-gl/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 23/24 - Uniforme 1",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2023",
      "fluminense 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/23-24-01/uni0.jpg",
      "/images/brasil/serie-a/fluminense/23-24-01/uni1.jpg",
      "/images/brasil/serie-a/fluminense/23-24-01/uni2.jpg",
      "/images/brasil/serie-a/fluminense/23-24-01/uni3.jpg",
      "/images/brasil/serie-a/fluminense/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 23/24 - Uniforme de Goleiro (Preto)",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "2023",
      "fluminense 2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/fluminense/23-24-05-gp/uni0.jpg",
      "/images/brasil/serie-a/fluminense/23-24-05-gp/uni1.jpg",
      "/images/brasil/serie-a/fluminense/23-24-05-gp/uni2.jpg",
      "/images/brasil/serie-a/fluminense/23-24-05-gp/uni3.jpg",
      "/images/brasil/serie-a/fluminense/23-24-05-gp/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 12/13 - Uniforme 1 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/12-13-01-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/12-13-01-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/12-13-01-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/12-13-01-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 10/11 - Uniforme 1 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/10-11-01-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/10-11-01-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/10-11-01-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/10-11-01-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/10-11-01-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 10/11 - Uniforme 2 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/10-11-02-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/10-11-02-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/10-11-02-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/10-11-02-rt/uni3.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 08/09 - Uniforme 1 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/08-09-01-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/08-09-01-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/08-09-01-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/08-09-01-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/08-09-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 07/08 - Uniforme 3 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/07-08-03-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/07-08-03-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/07-08-03-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/07-08-03-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/07-08-03-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 02/03 - Uniforme 1 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/02-03-01-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/02-03-01-rt/uni1.jpg",
      "/images/brasil/serie-a/fluminense/02-03-01-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/02-03-01-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/02-03-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "fluminense",
    nome: "Fluminense 93/94 - Uniforme 2 Retro",
    aliases: [
      "fluminense",
      "fluminense",
      "tricolor",
      "flu",
      "retro",
      "fluminense retro",
      "retro fluminense",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/fluminense/93-94-02-rt/uni0.jpg",
      "/images/brasil/serie-a/fluminense/93-94-02-rt/uni1.jpeg",
      "/images/brasil/serie-a/fluminense/93-94-02-rt/uni2.jpg",
      "/images/brasil/serie-a/fluminense/93-94-02-rt/uni3.jpg",
      "/images/brasil/serie-a/fluminense/93-94-02-rt/uni4.jpg",
    ],
  },
];

export default fluminense;
